
import routeIndex from "./landing";
import routeNotice from "./notice/route";
import routeGame from "./game/route";
import routeAdmin from "./admin/route";

export default  [
  ...routeIndex,
  ...routeNotice,
  ...routeGame,
  ...routeAdmin,
] ;